import messages from './suggestionsMessages';

// eslint-disable-next-line no-unused-expressions
export const roomsSuggestions = (intl) => [
  intl.formatMessage(messages.gym),
  intl.formatMessage(messages.heater),
  intl.formatMessage(messages.airConditioner),
  intl.formatMessage(messages.commomArea),
  intl.formatMessage(messages.commomAreaGym),
  intl.formatMessage(messages.commomAreaGrill),
  intl.formatMessage(messages.commomAreaPool),
  intl.formatMessage(messages.commonAreaPlayground),
  intl.formatMessage(messages.commonAreaPartyHall),
  intl.formatMessage(messages.serviceArea),
  intl.formatMessage(messages.externalArea),
  intl.formatMessage(messages.gourmetArea),
  intl.formatMessage(messages.bathroom),
  intl.formatMessage(messages.bathroomFaucet),
  intl.formatMessage(messages.bathroom1),
  intl.formatMessage(messages.bathroom2),
  intl.formatMessage(messages.hallBathroom),
  intl.formatMessage(messages.suiteBathroom),
  intl.formatMessage(messages.suiteBathroom1),
  intl.formatMessage(messages.suiteBathroom2),
  intl.formatMessage(messages.suiteBathroom3),
  intl.formatMessage(messages.suiteBathroom4),
  intl.formatMessage(messages.serviceBathroom),
  intl.formatMessage(messages.roomBathroom1),
  intl.formatMessage(messages.roomBathroom2),
  intl.formatMessage(messages.roomBathroom3),
  intl.formatMessage(messages.socialBathroom),
  intl.formatMessage(messages.kidsRoom),
  intl.formatMessage(messages.grill),
  intl.formatMessage(messages.shower),
  intl.formatMessage(messages.closet),
  intl.formatMessage(messages.roomCloset),
  intl.formatMessage(messages.roomCloset1),
  intl.formatMessage(messages.roomCloset2),
  intl.formatMessage(messages.roomCloset3),
  intl.formatMessage(messages.roomCloset4),
  intl.formatMessage(messages.suiteCloset),
  intl.formatMessage(messages.suiteCloset1),
  intl.formatMessage(messages.suiteCloset2),
  intl.formatMessage(messages.suiteCloset3),
  intl.formatMessage(messages.suiteCloset4),
  intl.formatMessage(messages.roof),
  intl.formatMessage(messages.condominium),
  intl.formatMessage(messages.kitchenPantry),
  intl.formatMessage(messages.hall),
  intl.formatMessage(messages.kitchen),
  intl.formatMessage(messages.kitchenCabinets),
  intl.formatMessage(messages.kitchenFaucet),
  intl.formatMessage(messages.kitchenAndServiceRoom),
  intl.formatMessage(messages.pantry),
  intl.formatMessage(messages.detail),
  intl.formatMessage(messages.serviceRoomDetail),
  intl.formatMessage(messages.kitchenDetail2),
  intl.formatMessage(messages.bathroomDetail2),
  intl.formatMessage(messages.suiteBathroomDetail),
  intl.formatMessage(messages.livingRoomDetail),
  intl.formatMessage(messages.shower2),
  intl.formatMessage(messages.building),
  intl.formatMessage(messages.entrance),
  intl.formatMessage(messages.stairs),
  intl.formatMessage(messages.office),
  intl.formatMessage(messages.gourmetSpace),
  intl.formatMessage(messages.facade),
  intl.formatMessage(messages.blockFacade),
  intl.formatMessage(messages.condominiumFacade),
  intl.formatMessage(messages.buildingFacade),
  intl.formatMessage(messages.facadeAndConcierge),
  intl.formatMessage(messages.garage),
  intl.formatMessage(messages.hall2),
  intl.formatMessage(messages.entranceHall),
  intl.formatMessage(messages.socialHall),
  intl.formatMessage(messages.garden),
  intl.formatMessage(messages.kitnet),
  intl.formatMessage(messages.toilet),
  intl.formatMessage(messages.laundry),
  intl.formatMessage(messages.laundryFaucet),
  intl.formatMessage(messages.sink),
  intl.formatMessage(messages.pool),
  intl.formatMessage(messages.indoorPool),
  intl.formatMessage(messages.playground),
  intl.formatMessage(messages.court),
  intl.formatMessage(messages.sportsCourt),
  intl.formatMessage(messages.room),
  intl.formatMessage(messages.roomCabinets),
  intl.formatMessage(messages.room1),
  intl.formatMessage(messages.roomCabinets1),
  intl.formatMessage(messages.room2),
  intl.formatMessage(messages.suiteRoom2),
  intl.formatMessage(messages.roomCabinets2),
  intl.formatMessage(messages.room3),
  intl.formatMessage(messages.suiteRoom3),
  intl.formatMessage(messages.roomCabinets3),
  intl.formatMessage(messages.room4),
  intl.formatMessage(messages.suiteRoom4),
  intl.formatMessage(messages.roomCabinets4),
  intl.formatMessage(messages.serviceRoom),
  intl.formatMessage(messages.suiteRoom),
  intl.formatMessage(messages.backyard),
  intl.formatMessage(messages.balcony),
  intl.formatMessage(messages.livingRoom),
  intl.formatMessage(messages.livingRoom1),
  intl.formatMessage(messages.livingRoom2),
  intl.formatMessage(messages.diningRoom),
  intl.formatMessage(messages.playroom),
  intl.formatMessage(messages.tvRoom),
  intl.formatMessage(messages.livingRoomAndKitchen),
  intl.formatMessage(messages.LivingRoomAndRoom),
  intl.formatMessage(messages.partyHall2),
  intl.formatMessage(messages.gameRoom),
  intl.formatMessage(messages.steamRoom),
  intl.formatMessage(messages.spa),
  intl.formatMessage(messages.studio),
  intl.formatMessage(messages.suite),
  intl.formatMessage(messages.suite1),
  intl.formatMessage(messages.suite2),
  intl.formatMessage(messages.suite3),
  intl.formatMessage(messages.suite4),
  intl.formatMessage(messages.masterSuite),
  intl.formatMessage(messages.terrace),
  intl.formatMessage(messages.porch),
  intl.formatMessage(messages.livingRoomPorch),
  intl.formatMessage(messages.gourmetPorch),
  intl.formatMessage(messages.view),
  intl.formatMessage(messages.streetView),
  intl.formatMessage(messages.balconyView),
  intl.formatMessage(messages.livingRoomView),
  intl.formatMessage(messages.suiteView),
  intl.formatMessage(messages.porchView),
  intl.formatMessage(messages.roomView),
  intl.formatMessage(messages.roomView1),
  intl.formatMessage(messages.roomView2),
];
